document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.ps-multicolumn-2__slider');

  sliders.forEach(function (el) {
    if (el.psSwiper) {
      el.psSwiper.destroy(true, true);
    }

    var slidesDesktop = parseInt(el.dataset.slidesDesktop) || 4;
    var slidesTablet = parseInt(el.dataset.slidesTablet) || 3;
    var slidesMobile = parseInt(el.dataset.slidesMobile) || 1;

    el.psSwiper = new Swiper(el, {
      slidesPerView: slidesMobile,
      spaceBetween: 16,
      centerInsufficientSlides: true,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      pagination: {
        el: el.querySelector('.ps-multicolumn-2__pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: slidesTablet,
          spaceBetween: 20,
          autoplay: false,
        },
        1024: {
          slidesPerView: slidesDesktop,
          spaceBetween: 24,
          autoplay: false,
        },
      },
    });
  });
});
